"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DayOfWeekTimer = function (_a) {
    // const t = useTranslations('translation')
    // const breakpoints = useBreakpoint()
    //
    // const promoActive = useMemo(() => {
    //   return false
    //   // return checkPromoDay(activeDayOfWeek)
    // }, [])
    var activeDayOfWeek = _a.activeDayOfWeek, hideFinishLabel = _a.hideFinishLabel;
    return null;
    // return (
    //   <>
    //     {/*{promoActive?.active ? (*/}
    //     {promoActive?.active ? (
    //       <div className={styles.active}>{t('active')}</div>
    //     ) : (
    //       <div className={styles.timerWrapper}>
    //         <Timer
    //           endDate={promoActive?.startAt}
    //           inGame={breakpoints.mobile || breakpoints.tablet}
    //           title={t('startAfter')}
    //           hideFinishLabel={hideFinishLabel}
    //         />
    //       </div>
    //     )}
    //   </>
    // )
};
exports.default = DayOfWeekTimer;
